import { action, observable } from 'mobx';
import { SerializedData } from 'bernie-core';
import { AnalyticsStore } from 'bernie-plugin-mobx';
import { RequestOptions } from 'bernie-graphql';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';

import { BaseBexApiStore } from './bex-api-store';
import analyticsWrapper from 'utility/analytics-wrapper';
import { clientInfoHeader } from 'utility/header-utils';
import { FlightsShoppingPwaFlightServicingConfirmationResults } from 'src/__generated__/api';

export class FlightServicingConfirmationStore extends BaseBexApiStore {
  @observable public confirmationHeading: string;

  public hydrate(data: SerializedData): void {
    super.hydrate(data);
    Object.assign(this, data);
    this.bexApiSource.clientConfigs.bexApiUrl = '/graphql';
  }

  @action
  public setConfirmationHeading(heading: string) {
    this.confirmationHeading = heading;
  }

  public fetchResults(
    variables: FlightsShoppingPwaFlightServicingConfirmationResults.Variables,
    options: RequestOptions,
    analytics: AnalyticsStore
  ): Promise<FlightsShoppingPwaFlightServicingConfirmationResults.FlightsServicingConfirmation> {
    const { appName, region } = this.bexApiSource.clientConfigs;
    this.bexApiSource.headers = clientInfoHeader(this.bexApiSource.headers, appName, region);

    return this.bexApiSource.operations
      .flightsShoppingPwaFlightServicingConfirmationResults(variables, options)
      .then(response => {
        const { flightsServicingConfirmation } = response?.data ?? {};

        analyticsWrapper.publishAnalyticsPayload(response, analytics);

        return flightsServicingConfirmation;
      })
      .catch(error => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.CRITICAL, 'SERVICING_CONFIRMATION_FETCH'), error);

        return null;
      });
  }
}

FlightServicingConfirmationStore.DEFAULTS = {
  confirmationHeading: ''
};
